<template>
    <div id="data-list-thumb-view" class="data-list-container">
        <vs-table ref="table" :max-items="20" pagination search :data="categories">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <h1>Copmpany Categorieën</h1>
                <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                >Categorie toevoegen
                    <!--                    <span class="ml-2 text-base text-primary" @click="openCreateInvoiceableModal">Toevoegen</span>-->
                </div>
            </div>
            <template slot="thead">
                <vs-th sort-key="company_name">Naam</vs-th>

            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr
                        :data="category"
                        :key="index"
                        v-for="(category, index) in data"
                        @click.native="openCategoryPopup(category)">

                    <vs-td>
                        <p class="category-name">{{ category.name }}</p>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <ht-category-popup></ht-category-popup>
    </div>
</template>
<script>
    import CompanyCategoryPopup from "./CategoryPopup";

    export default {
        data() {
            return {
                categories: []
            }
        },

        components: {
            "ht-category-popup": CompanyCategoryPopup
        },

        methods: {
            getCompanyCategories() {
                this.$http.get('/v1/company-categories')
                    .then((response) => {
                        this.categories = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },

            openCategoryPopup(category) {
                this.$events.fire('open-category-popup', category);
            }
        },

        mounted() {
            this.getCompanyCategories();
        }
    }
</script>